import { api } from '@/shared/api/axios';
import { unwrapSingle } from '@/shared/api/unwrap';

const base = (depId) => `/deployments/${depId}/production-day`;

export const productionDayApi = {
  // Resolved window: { startTime, endTime, source }. Never 404s (falls back to default).
  get: (depId) => api.get(base(depId)).then(unwrapSingle),

  // Store an override. Body is { startTime, endTime } with endTime === startTime.
  set: (depId, payload) => api.put(base(depId), payload).then(unwrapSingle),

  // Clear the override (revert to default). Returns 204.
  clear: (depId) => api.delete(base(depId)).then((r) => r.data),
};
